import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import CustomBtn from '../CustomBtn';
import { appStore } from '../../state/app';
import storage from '../../utils/storage';

const CustomPopup = ({ text, handleClick }) => {
  const history = useHistory();
  const { state } = useContext(appStore);
  const { wallet } = state;
  const btnPoppup = () => {
    if (text.type === 'email') {
      return (
        <CustomBtn
          label="Change wallet"
          handleClick={() => {
            wallet.changeWallet();
            storage.del('token');
          }}
          customClass="modal_btn_item green"
        />
      );
    } if (text.type === 'valid') {
      return (
        <CustomBtn
          label="Ok"
          handleClick={() => {
            handleClick();
            history.push('/');
          }}
          customClass="modal_btn_item green"
        />
      );
    }
    return (
      <CustomBtn
        label="Сlick to login"
        handleClick={() => {
          handleClick();
          history.push('/login');
        }}
        customClass="modal_btn_item green"
      />
    );
  };
  return (
    <div className="custom-modal custom">
      <div className="custom-modal__bg" onClick={handleClick} />
      <div className="custom-modal_wrap">
        <p className="custom-modal__text">{text.text}</p>
        <div className="custom-modal_btn">
          {btnPoppup()}
        </div>
      </div>
    </div>
  );
};

export default CustomPopup;
